export default __webpack_public_path__ + "static/media/sprto.e1ceeca6.png";